module.exports = __webpack_public_path__ + "2597c7c87e7da1a7ea10a8bb2944ddfd.png";